import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "login-shell" }
const _hoisted_2 = { class: "login-right" }
const _hoisted_3 = { class: "login-content" }
const _hoisted_4 = { class: "input-field" }
const _hoisted_5 = { class: "input-field" }
const _hoisted_6 = { class: "input-field" }
const _hoisted_7 = {
  key: 0,
  class: "login-error"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 1,
  class: "login-loading"
}
const _hoisted_10 = { class: "login-links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[11] || (_cache[11] = _createElementVNode("section", {
      class: "login-left",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", { class: "brand-panel" }, [
        _createElementVNode("h2", { class: "brand-name" }, "Obra Tycoon")
      ])
    ], -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "login-header" }, [
          _createElementVNode("h1", { class: "login-title" }, "Entrar")
        ], -1)),
        _createElementVNode("form", {
          class: "form-grid",
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { for: "systemUsername" }, "Identificador da obra", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "systemUsername",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.systemUsername) = $event)),
              type: "text",
              placeholder: "Ex.: relatorioshow",
              autocomplete: "organization"
            }, null, 512), [
              [_vModelText, _ctx.systemUsername]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { for: "username" }, "Usuário", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "username",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.username) = $event)),
              type: "text",
              placeholder: "Ex.: gusmachado",
              autocomplete: "username"
            }, null, 512), [
              [_vModelText, _ctx.username]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { for: "password" }, "Senha", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "password",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
              type: "password",
              placeholder: "Digite sua senha",
              autocomplete: "current-password"
            }, null, 512), [
              [_vModelText, _ctx.password]
            ])
          ]),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn-primary",
            type: "submit",
            disabled: _ctx.loading
          }, _toDisplayString(_ctx.loading ? 'Aguarde...' : 'Entrar'), 9, _hoisted_8),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, "As informações estão carregando, aguarde um momento."))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "link-btn",
              type: "button",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.forgotPassword && _ctx.forgotPassword(...args)))
            }, "Esqueci minha senha"),
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "link-sep" }, "·", -1)),
            _createElementVNode("button", {
              class: "link-btn",
              type: "button",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goRegister && _ctx.goRegister(...args)))
            }, "Registrar obra")
          ])
        ], 32)
      ])
    ])
  ]))
}